

import React, { memo } from 'react';
import cx from 'classnames';
import onEnterPressed from '@shootsta/on-enter-pressed';
import { DROPDOWN_OPTION, DROPDOWN_LABEL } from '../styles/dropdownLabel';
import { getPrefix } from '../utils';
import Checkbox from '../../Checkbox/components/Checkbox';
import DropdownLabelContent from './DropdownLabelContent';
import '../styles/_dropdown-label.scss';











const handleSelectOption = (selectOption, data) => () => {
  if (selectOption) {
    selectOption(data);
  }
};

function DropdownLabel(
{
  data,
  data: {
    prefix,
    prefixSize,
    label,
    value,
    suffix,
    disabled: labelDisabled
  },
  selectOption,
  isSelected,
  isMulti,
  disabled,
  cutLongLabels
})
{
  return (
    <div
      className={cx(
        'dropdown-option',
        { 'dropdown-option--disabled': labelDisabled },
        DROPDOWN_OPTION
      )}
      onClick={handleSelectOption(selectOption, data)}
      tabIndex={0}
      role="button"
      onKeyPress={onEnterPressed({ onClick: handleSelectOption(selectOption, data) })}
      data-testid={`option-${value}`}>

      {
      isMulti ?
      <Checkbox checked={isSelected} onChange={handleSelectOption(selectOption, data)} /> :
      null}

      <div className={cx('dropdown-option__content', DROPDOWN_LABEL)}>
        {getPrefix({ prefix, size: prefixSize })}
        <DropdownLabelContent
          label={label}
          disabled={disabled}
          cutLongLabels={cutLongLabels} />

      </div>
      {suffix ? <div className="dropdown-option__suffix">{suffix}</div> : null}
    </div>);

}

DropdownLabel.defaultProps = {
  suffix: null
};

export default memo(DropdownLabel);